module.exports = __webpack_public_path__ + "img/logo10.82af8155.png";